var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item-icon",
      class: _vm.classes,
      on: {
        mouseover: function($event) {
          _vm.show(true)
        },
        mouseleave: function($event) {
          _vm.show(false)
        }
      }
    },
    [
      _c("img", { attrs: { src: _vm.item.icon } }),
      _vm.item.sockets
        ? _c("item-sockets", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hovered,
                expression: "hovered"
              }
            ],
            attrs: {
              sockets: _vm.item.sockets,
              gems: _vm.item.socketedItems,
              h: _vm.item.h,
              w: _vm.item.w
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
/* hot reload */
if (module.hot) {
  var api = require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (module.hot.data) {
      require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js").rerender('d865188e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    }
  }
}export { render, staticRenderFns }